/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React from 'react';
import { colors } from '@material-ui/core';
import DashboardIcon from '@material-ui/icons/DashboardOutlined';
import PeopleIcon from '@material-ui/icons/PeopleOutlined';
import MenuBook from '@material-ui/icons/MenuBook';
import SettingsIcon from '@material-ui/icons/Settings';
import ViewList from '@material-ui/icons/ViewList';

import { Label } from 'components';

export default [
  {
    key: 0,
  },
  {
    key: 1,
    pages: [
      {
        title: 'داشبورد',
        href: '/',
        icon: DashboardIcon
      },
      {
        title: 'اساتید',
        href: '/instructors',
        icon: PeopleIcon,
      },
      {
        title: 'مصححان',
        href: '/correctors',
        icon: PeopleIcon,
      },
      {
        title: 'دروس',
        href: '/courses',
        icon: MenuBook,
      },
      {
        title: 'امتحانات',
        href: '/exams',
        icon: ViewList,
      },
      // {
      //   title: 'دانشجویان',
      //   href: '/instructors',
      //   icon: PeopleIcon,
      // },
      // {
      //   title: 'تنظیمات',
      //   href: '/instructors',
      //   icon: SettingsIcon,
      // },
    ]
  },
  {
    key: 2,
    pages: [
      {
        title: 'داشبورد',
        href: '/',
        icon: DashboardIcon
      },
      {
        title: 'اساتید',
        href: '/instructors',
        icon: PeopleIcon,
      },
      {
        title: 'مصححان',
        href: '/correctors',
        icon: PeopleIcon,
      },
      {
        title: 'دروس',
        href: '/courses',
        icon: MenuBook,
      },
      {
        title: 'امتحانات',
        href: '/exams',
        icon: ViewList,
      },
      // {
      //   title: 'دانشجویان',
      //   href: '/instructors',
      //   icon: PeopleIcon,
      // },
      // {
      //   title: 'تنظیمات',
      //   href: '/instructors',
      //   icon: SettingsIcon,
      // },
    ]
  },
  {
    key: 3,
    pages: [
      {
        title: 'داشبورد',
        href: '/',
        icon: DashboardIcon
      },
      {
        title: 'اساتید',
        href: '/instructors',
        icon: PeopleIcon,
      },
      {
        title: 'مصححان',
        href: '/correctors',
        icon: PeopleIcon,
      },
      {
        title: 'دروس',
        href: '/courses',
        icon: MenuBook,
      },
      {
        title: 'امتحانات',
        href: '/exams',
        icon: ViewList,
      },
      // {
      //   title: 'دانشجویان',
      //   href: '/instructors',
      //   icon: PeopleIcon,
      // },
      // {
      //   title: 'تنظیمات',
      //   href: '/instructors',
      //   icon: SettingsIcon,
      // },
    ]
  },
  {
    key: 4,
    pages: [
      {
        title: 'داشبورد',
        href: '/',
        icon: DashboardIcon
      },
    ]
  }
];
